import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { parseExpenseData } from '@/utils/approval/expensePreApproval';
import {
  buildExpenseSnapshotHtml,
  isExpenseSnapshotHtml,
  sanitizeExpenseSnapshotHtml,
} from '@/utils/approval/expensePreApprovalHtml';
import type { ContentExtraProps } from '../../types';
import { ExpensePreApprovalSlotRoot } from './styles';

/**
 * 205 사전 비용 — 저장 시점 HTML 스냅샷(attributes.content)으로 그림. 결재 후 서버 재계산·코드 변경과 무관하게
 * 작성자가 상신한 내용 그대로. 스냅샷이 없는 레거시 작성 문서만 attributes.data 로 같은 HTML 을 만들어 그림
 */
const ExpensePreApprovalSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const html = useMemo(() => {
    const content = data.attributes?.content;
    if (isExpenseSnapshotHtml(content)) {
      return sanitizeExpenseSnapshotHtml(content);
    }
    const expense = parseExpenseData(data.attributes);
    return expense
      ? sanitizeExpenseSnapshotHtml(buildExpenseSnapshotHtml(expense, t))
      : '';
  }, [data.attributes, t]);

  if (!html) return null;
  // 허용 태그·속성만 남긴 HTML(sanitizeExpenseSnapshotHtml)
  // eslint-disable-next-line react/no-danger
  return (
    <ExpensePreApprovalSlotRoot dangerouslySetInnerHTML={{ __html: html }} />
  );
};

export default ExpensePreApprovalSlot;
